<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.exercise') }} <strong>{{ exercise?.name }}</strong> - {{ t('common.labels.create_element') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.exercise') }} <strong>{{ element.exercisename }}</strong> - {{ t('common.labels.element') }} <strong>{{ element.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-element-new *ngIf="newMode()" [exercise]="exercise"></app-element-new>
          <app-element-basedata *ngIf="editMode()" [exercise]="exercise" [element]="element" (setEdit)="setEdit($event)"></app-element-basedata>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.content') }}" leftIcon="pi pi-align-left" [disabled]="isDisabled('content') || element === null">
          <app-element-content [exercise]="exercise" [element]="element" (setEdit)="setEdit($event)"></app-element-content>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.visibility') }}" leftIcon="pi pi-eye" [disabled]="isDisabled('visibility') || element === null">
          <app-element-visibility [exercise]="exercise" [element]="element" (setEdit)="setEdit($event)"></app-element-visibility>
        </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
